import React from "react";
import Paper from "@material-ui/core/Paper";
import { Container } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import { Col, Input } from "reactstrap";
import { Card, CardTitle } from "reactstrap";
import axios from "axios";
import base_URL from "../../base_URL";
import TableContainer from "@material-ui/core/TableContainer";
import {  Link } from "react-router-dom";
import { Row } from "reactstrap";
import { Redirect } from "react-router-dom";

class Themes extends React.Component {
  constructor() {
    super();
    this.state = {
      input: {
        theme: "0",
      },
      data: [],
    };

    this.handleChange = this.handleChange.bind(this);

    this.loadService = this.loadService.bind(this);
    this.deleteTheme = this.deleteTheme.bind(this);
    this.AddService = this.AddService.bind(this);
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({
      input,
    });
  }

  loadService = async () => {
    await axios.get(`${base_URL}/theme/all`, {}).then((response) => {
      this.setState({
        data: response.data,
      });
    });
  };

  componentDidMount() {
    this.loadService();
  }

  deleteTheme = async (id) => {
    await axios.delete(`${base_URL}/theme/del/${id}`);
    this.loadService();
  };

  AddService = async () => {
    let theme = this.state.input.theme;
    if (theme != "0") {
      await axios.post(`${base_URL}/theme/theme/${theme}`);
      
    }
    this.loadService();
    
  };

  render() {
    if (localStorage.getItem("Admin1token") == null)
    return <Redirect to="/login" />;

    return (
      <Container id="container">
        <Card body style={{ margin: "20px" }} id="Card">
          <CardTitle>
            <h1>Service Provider Details</h1>
          </CardTitle>
         
            <Row>
              <Col xs={12} md={6}>
                <div class="form-group">
                  <Input
                    type="text"
                    name="theme"
                    onChange={this.handleChange}
                    className="form-control"
                    placeholder="Service Type"
                    id="for"
                  ></Input>
                </div>
              </Col>
              <Col xs={12} md={6}>
                <div class="form-group">
                  <Link
                    type="button"
                    class="btn btn-success"
                    onClick={() => this.AddService()}
                  >
                    Add
                  </Link>
                </div>
              </Col>
            </Row>
        
        </Card>

        <div style={{ marginTop: "10px" }}>
          <Paper>
            <TableContainer>
              <Table responsive className="table border shadow">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col"> Id</th>
                    <th scope="col">ThemeName</th>
                    <th scope="col">Count</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data.map((record, index) => (
                    <tr>
                      <th scope="row">{index + 1}</th>
                      <td>{record.id}</td>
                      <td>{record.themeName}</td>
                      <td>{record.count}</td>

                      <td>
                        <Link
                          type="button"
                          class="btn btn-danger"
                          onClick={() => this.deleteTheme(record.id)}
                        >
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </TableContainer>
          </Paper>
        </div>
      </Container>
    );
  }
}
export default Themes;
